module.exports = __webpack_public_path__ + "static/media/24.793ea1d7.jpg";